import React, { useState } from 'react';
import { ComchekDataObject } from '../../../interfaces/comchek';
import PutBody from '../../../api/internal/PutBody';
import Button from '../../../assets/essentials/Button';
import Select from '../../../assets/essentials/Select';
import Create from '../../../helpers/modal/CreateModal';
import CloseSlab from '../../../helpers/slab/Close';
import CloseModal from '../../../helpers/modal/CloseModal';
import Modal from '../../../helpers/modal/Modal';
import OptionList from '../../../helpers/options/OptionList';
import classes from '../../../assets/Global.module.css';

function Admin({
  data,
  comchekId,
  RefreshPage,
}: {
  data: ComchekDataObject['Admin'];
  comchekId: number;
  RefreshPage: Function;
}) {
  const [vendorId, setVendorId] = useState(data.vendorId);
  const [isLoading, setIsLoading] = useState(false);

  const handleUpdateComchekAdmin = () => {
    setIsLoading(true);
    PutBody('/Comchek/UpdateComchekAdmin', {
      comchekId: comchekId,
      vendorId: vendorId,
    })
      .then(response => {
        if (response) {
          RefreshPage('Admin', ['Audit', 'Summary']);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const DeleteComchekModal = () => {
    const handleDeleteComchek = () => {
      PutBody('/Comchek/UpdateComchekAdmin', {
        comchekId: comchekId,
        vendorId: vendorId,
        isActive: false,
      }).then(response => {
        if (response) {
          CloseModal();
          CloseSlab();
        }
      });
    };

    return (
      <Modal>
        <div className={classes.flexColumnAlignCenter}>
          <h4>Delete Comchek</h4>
          <p>Are you sure you want to delete this Comchek?</p>
          <div className={classes.sideBySideButtons}>
            <Button onClick={handleDeleteComchek} variant="bad">
              Delete
            </Button>
            <Button onClick={CloseModal}>Cancel</Button>
          </div>
        </div>
      </Modal>
    );
  };

  const handleClick = () => {
    Create(<DeleteComchekModal />);
  };

  return (
    <>
      <div className={`${classes.span3} ${classes.attribute}`}>
        <label htmlFor='vendorId'>Vendor</label>
        <Select
          value={vendorId?.toString() || ''}
          onChange={e => setVendorId(parseInt(e.target.value))}
        >
            <option value="">--No Vendor--</option>
          <OptionList
            optionData={data.vendorOptions}
            attributeID="vendorId"
            attributeName={'name'}
          />
        </Select>
      </div>
      <div>
        <Button
          onClick={handleUpdateComchekAdmin}
          disabled={isLoading}
          variant="good"
          type="button"
        >
          {isLoading ? 'Saving...' : 'Save Changes'}
        </Button>
      </div>
      <div>
        <Button onClick={handleClick}>Delete Comchek</Button>
      </div>
    </>
  );
}

export default Admin;
